// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"announcements__wrapper--1E8Fs","module_wrapper":"announcements__module_wrapper--2uj8Z","moduleWrapper":"announcements__module_wrapper--2uj8Z"};